export default "__VITE_ASSET__9dc675e5__"